import React from 'react'
import { useFormik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Typography, InputLabel, FormControl, FormHelperText } from '@material-ui/core'
import { promocodeBulkImportFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import { useStyles } from './Styles'
import Configuration from '../../../../../Services/Api/Configuration'
import { ExcelIcon } from '../../../../../utils/helpers'
import promocodeTemplate from '../../../../../assets/promocodeBulkTemplate.xlsx'

const PromocodeBulkImportForm = ({ onSubmit, cancelDialog, bulkImportHasError, clearBulkImportError, reloadPage }) => {
  const intl = useIntl()
  const classes = useStyles()
  const [filesName, setFilesName] = React.useState(intl.formatMessage({ id: 'PromocodeBulkImport.placeholder.file' }))

  const promocodeBulkImportFormActions = useFormik({
    initialValues: {
      promocodesFile: null
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: promocodeBulkImportFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions, cancelDialog, reloadPage)
    })
  })

  const handleFileChange = (event, fieldName) => {
    event.preventDefault()
    clearBulkImportError()
    let files = event.currentTarget.files
    if (files && files.length > 0) {
      if (!!promocodeBulkImportFormActions.errors[fieldName]) {
        promocodeBulkImportFormActions.setFieldError(fieldName, null)
      }
      let file = files[0]
      const types = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
      if (types.includes(file.type)) {
        if (file.size <= Configuration.UPLOAD_FILE_SIZE) {
          promocodeBulkImportFormActions.setFieldValue(fieldName, file)
          setFilesName(event.target.value.replace(/.*(\/|\\)/, ''))
        } else {
          promocodeBulkImportFormActions.setFieldTouched(fieldName, true, true)
          setTimeout(() => promocodeBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.largeFile' })), 50)
        }
      } else {
        promocodeBulkImportFormActions.setFieldTouched(fieldName, true, true)
        setTimeout(() => promocodeBulkImportFormActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.unSupported' })), 50)
      }
    }
  }

  // Reset file input when there's an error
  React.useEffect(() => {
    if (bulkImportHasError) {
      promocodeBulkImportFormActions.setFieldTouched('promocodesFile', false)
      promocodeBulkImportFormActions.setFieldValue('promocodesFile', null)
      setFilesName(intl.formatMessage({ id: 'PromocodeBulkImport.placeholder.file' }))
      const fileInput = document.getElementById('promocodesFile')
      if (fileInput) {
        fileInput.value = ''
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkImportHasError])

  return (
    <form onSubmit={promocodeBulkImportFormActions.handleSubmit} noValidate autoComplete="off"
      className={classes.formWrapper}>
      <>
        <Typography className={classes.templateTitle} variant={'h6'}>
          <FormattedMessage id='PromocodeBulkImport.template.title' />
        </Typography>

        <div className={classes.templateDownloadWrapper}>
          <Button
            className={classes.templateDownload}
            color={'primary'}
            startIcon={<ExcelIcon htmlColor="#fff" />}
            href={promocodeTemplate}
            download='promocodeBulkTemplate.xlsx'
          >
            promocodeBulkTemplate.xlsx
          </Button>
        </div>

        <div className={classes.BasicInfoRow}>
          <InputLabel htmlFor="promocodesFile">
            <FormattedMessage id='PromocodeBulkImport.label.file' />
            <span className={'required'}>*</span>:
          </InputLabel>
          <FormControl variant="outlined" margin="dense">
            <div className={classes.fileUploadWrapper} data-text={filesName}>
              <input
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                className={classes.fileUpload}
                name="promocodesFile"
                id="promocodesFile"
                type="file"
                onChange={(event) => handleFileChange(event, 'promocodesFile')}
              />
            </div>
            {promocodeBulkImportFormActions.errors.promocodesFile && promocodeBulkImportFormActions.touched.promocodesFile && (
              <FormHelperText error={true}>{promocodeBulkImportFormActions.errors.promocodesFile}</FormHelperText>
            )}
          </FormControl>
        </div>
      </>

      <div className={classes.FormSubmitRow}>
        <Button type="submit" variant='contained' size='large' color='primary'
          onClick={promocodeBulkImportFormActions.handleSubmit}
          disabled={promocodeBulkImportFormActions.isSubmitting || !promocodeBulkImportFormActions.isValid}
        >
          <FormattedMessage id='PromocodeBulkImport.button.submit' />
        </Button>
      </div>
      {!!promocodeBulkImportFormActions.isSubmitting && <FormLoader loading={true} />}
    </form>
  )
}

export default PromocodeBulkImportForm

